const ALLOWED_SETTINGS = new Set([
  'Settings Agents',
  'Settings Teams',
  'Settings Inboxes',
  'Settings Labels',
  'Settings Automation',
  'Settings Agent Bots',
  'Settings Canned Responses',
  'Settings Integrations',
]);

export const filterCerebroNavigation = items =>
  items
    .filter(item => !['Campaigns', 'Captain'].includes(item.name))
    .map(item => {
      if (item.name === 'Reports') {
        return {
          ...item,
          children: item.children.filter(
            child => !['Reports CSAT', 'Reports SLA'].includes(child.name)
          ),
        };
      }

      if (item.name === 'Settings') {
        return {
          ...item,
          children: item.children.filter(child => ALLOWED_SETTINGS.has(child.name)),
        };
      }

      return item;
    });

export const filterCerebroIntegrations = integrations =>
  integrations.filter(integration => integration.id !== 'webhook');
